package de.oevbs.kunde.kundenportal2.services.delivery

import de.oevbs.businesspartner.bpcrmservice2.partner.model.Dispatch
import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.delivery.currentOption
import de.oevbs.kunde.kundenportal2.model.services.inbox.DeliveryState
import de.oevbs.kunde.kundenportal2.model.services.inbox.delivery
import de.oevbs.kunde.kundenportal2.navigation.visit
import dev.fritz2.core.RenderContext
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.map

//TODO Delivery Dateien sortieren, sollen die zu Postfach? Es gibt mehrere Modelle!

fun RenderContext.delivery() {

    val store = DeliveryStore(job)

    headerImageLayout {
        title(Pages.inboxDelivery.linkTitle)
        content {
            store.init(Unit)
            store.step.render { step ->
                when (step) {
                    GeneralProgressStep.SUBMIT1 -> renderSubmitStep(store)
                    GeneralProgressStep.SUCCESS2 -> renderSuccess(store)
                }
            }
        }
    }
}

private fun RenderContext.renderSubmitStep(store: DeliveryStore) {
    contentContainer {

        globalInitTracker.data.combine(store.initFailedFlow, ::Pair).render { (loading, failed) ->
            if (loading) return@render
            when {
                failed -> noPartnerDataFoundMessage()
                else -> renderSubmitStepAfterInit(store)
            }
        }
    }
}

private fun RenderContext.renderSubmitStepAfterInit(store: DeliveryStore) {
    paragraph {
        +"An dieser Stelle können Sie den Versandweg für Ihre Beitragsrechnungen und weitere Dokumente ändern."
        br {}
        +" Sie haben die Wahl zwischen Post- und Mailversand. Die Mail-Zustellung erfolgt auf Ihre hinterlegte"
        +" Mail-Adresse "
        b { store.crmMailAddress.renderText(into = this) }
        +". Zusätzlich finden Sie alle Dokumente im "
        textualButton("Posteingang") handledBy { Pages.inboxInbox.visit() }
        +" von "
        b { +"Meine Öffentliche" }
        +"."
    }
    card {
        paragraph {
            +"Aktuell werden Ihre Dokumente und andere Mitteilungen auf folgendem Weg an Sie versendet: "
            b { store.dispatch.renderText(into = this) }
            +"."
        }

        imageToggleKupo<Dispatch> {
            value.single(store.map(DeliveryState.delivery().currentOption()))
            label(Pages.inboxDelivery.linkTitle, visible = false)
            options = listOf(Dispatch.EMail, Dispatch.Post)
            optionsIcon = { option ->
                when (option) {
                    Dispatch.Post -> MaterialIconsOutlined.mail
                    Dispatch.EMail -> MaterialIconsOutlined.alternate_email
                    else -> MaterialIconsOutlined.error
                }
            }
            optionsFormat = { if (it == Dispatch.EMail) "Mail" else it.value }
        }
    }

    buttonContainer {
        btn {
            label("Versandweg ändern")
            disabled(store.unchanged)
            busy(globalSubmitTracker.data)
        }.clicks.map { store.current.delivery.currentOption } handledBy store.changeDispatch
    }
}

private fun RenderContext.renderSuccess(store: DeliveryStore) {
    store.data.map { it.delivery.currentOption }.render { dispatchOption ->
        messagePagePre(
            "Änderung erfolgreich.",
            PortalContactNotes.DeliveryMethodChanged(if (dispatchOption == Dispatch.EMail) "Mail" else dispatchOption.value).note
        )
    }
}